import { SVGProps } from 'react';

const FilePlaceholderIcon = ({
  height = '52px',
  width = '42px',
  strokeWidth = 2,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 42 52'
    className='stroke-current'
    {...props}
  >
    <g id='file_svg' transform='translate(-1443 -2210)'>
      <g
        id='Icons_Actions_ic-actions-file'
        data-name='Icons / Actions / ic-actions-file'
        transform='translate(1444 2211)'
      >
        <g id='ic-actions-file'>
          <path
            id='Path_18'
            data-name='Path 18'
            d='M31.15,2H9A5,5,0,0,0,4,7V47a5,5,0,0,0,5,5H39a5,5,0,0,0,5-5V19.3a2.35,2.35,0,0,0-.45-1.425L33.175,3.075A2.5,2.5,0,0,0,31.15,2Z'
            transform='translate(-4 -2)'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='bevel'
            strokeWidth={strokeWidth}
            fillRule='evenodd'
          />
        </g>
      </g>
      <g
        id='Icons_Layout_ic-layout-footer'
        data-name='Icons / Layout / ic-layout-footer'
        transform='translate(1451 2218)'
      >
        <g id='Group_4198' data-name='Group 4198'>
          <line
            id='Line_568'
            data-name='Line 568'
            x2='26'
            transform='translate(0 14)'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={strokeWidth}
          />
          <line
            id='Line_569'
            data-name='Line 569'
            x2='10.185'
            transform='translate(15.185 21.111)'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={strokeWidth}
          />
          <line
            id='Line_570'
            data-name='Line 570'
            x2='10.185'
            transform='translate(15.185 28.148)'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={strokeWidth}
          />
          <line
            id='Line_571'
            data-name='Line 571'
            x2='26'
            transform='translate(0 35)'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={strokeWidth}
          />
          <rect
            id='Rectangle_16976'
            data-name='Rectangle 16976'
            width='10'
            height='10'
            rx='1'
            transform='translate(0 20)'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={strokeWidth}
          />
          <line
            id='Line_582'
            data-name='Line 582'
            x2='18'
            transform='translate(0 7)'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={strokeWidth}
          />
          <line
            id='Line_583'
            data-name='Line 583'
            x2='13'
            transform='translate(0 0)'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={strokeWidth}
          />
        </g>
      </g>
    </g>
  </svg>
);

export default FilePlaceholderIcon;
